import { render, staticRenderFns } from "./companyhead.vue?vue&type=template&id=3cab692c"
import script from "./companyhead.vue?vue&type=script&lang=js"
export * from "./companyhead.vue?vue&type=script&lang=js"
import style0 from "./companyhead.vue?vue&type=style&index=0&id=3cab692c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DealerTisk: require('/root/workspace/web-company_Yo6Q/components/dealer/head/dealerTisk.vue').default})
